import { render, staticRenderFns } from "./availability-graph-settings.vue?vue&type=template&id=0585b818&"
import script from "./availability-graph-settings.vue?vue&type=script&lang=js&"
export * from "./availability-graph-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports